module.exports = __webpack_public_path__ + "static/media/auditorium-door-close.dab7d3e3.png";